import React from 'react';
import { colors } from '@material-ui/core';
import { BLOCK_TYPE_KEYS } from '@/lib/constants';
import { getRecipientColor } from '@/lib/utils';
import { type IBlockWithSignerNumber } from '@/store/applyTemplate/types';
import BlockPreview from './BlockPreview';

export interface BlockPreviewLayerProps {
  blocks: IBlockWithSignerNumber[];
  pageIndex: number;
  pageDimensions: { x: number; y: number };
}

export function BlockPreviewLayer(props: BlockPreviewLayerProps) {
  const { blocks, pageIndex, pageDimensions } = props;

  return (
    <>
      {blocks
        ?.filter((block) => block.pageNumber === pageIndex) // block.pageNumber is 0-indexed
        ?.filter((block) => block.x! + block.width! <= pageDimensions.x && block.y! + block.height! <= pageDimensions.y)
        .map((block) => (
          <BlockPreview
            key={block.blockId}
            block={block}
            color={getBlockColor(block)}
            pageDimensions={pageDimensions}
          />
        ))}
    </>
  );
}

function getBlockColor(block: IBlockWithSignerNumber) {
  if (block.blockType === BLOCK_TYPE_KEYS.STRIKE) {
    return '#000';
  } else if (block.blockType === BLOCK_TYPE_KEYS.RECTANGLE) {
    return block.bgColor ?? '';
  } else if (block.signerNumber > -1) {
    return getRecipientColor(block.signerNumber + 1);
  } else {
    return colors.grey[500];
  }
}
